import React from 'react';
import AiAgentLogoUrl from '@/assets/icons/ai-agent-log.png';
import Unread from '@/layouts/main-layout/components/unread';
import cn from 'classnames';

interface AiAgentLogoProps {
  /**
   * 未读消息数量
   */
  unreadCount?: number;
  onClick?: () => void;
  className?: string;
}

export const AiAgentLogo: React.FC<AiAgentLogoProps> = ({ unreadCount = 0, onClick, className }) => {
  return (
    <div className={cn('relative', onClick ? 'cursor-pointer' : '', className)} onClick={onClick}>
      <img src={AiAgentLogoUrl} alt="ai-agent-logo" className=" w-[42px] h-[42px]" />
      <div className=" absolute right-0 bottom-0">{unreadCount > 0 ? <Unread count={unreadCount} /> : null}</div>
    </div>
  );
};
